function debounce(fn, wait) {
  let t
  return (...args) => {
    clearTimeout(t)
    t = setTimeout(() => fn.apply(this, args), wait)
  }
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: `application/${type}`,
    },
  }
}

// taken from Shopify Dawn theme
if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super()

        this.addEventListener(
          'change',
          debounce(async event => {
            const body = JSON.stringify({ note: event.target.value })
            await fetch(`${mosmosh.cart.cart_update_url}`, {
              ...fetchConfig(),
              ...{ body },
            })
          }, 300)
        )
      }
    }
  )
}
